var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{staticClass:"treatment-lvs-description",class:{
    'is-success': _vm.isSuccess,
    'is-error': _vm.isError,
  },attrs:{"loading":_vm.isLoading,"textarea":"","rows":"3","hide-details":"","value":_vm.$attrs.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }